import styled from 'styled-components';
import { Card as DefCard } from '@blueprintjs/core';

export const Card = styled(DefCard)`
    width: 100%;
    height: 100%;
    overflow-y: auto;
`;
